/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var modelGet = require('common/util/modelGet');
var BreadcrumbView = require('common/views/BreadcrumbView');
var EntityHeaderBarView = require('../../common/views/EntityHeaderBarView');

var EntityOfficerNewApplication = require('../forms/EntityOfficerNewApplication');

var tmplEntityOfficerNewView = require('../templates/EntityOfficerNewView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplEntityOfficerNewView,

  className: 'entity-officer-new-view container-fluid',

  ui: {
    headerBarContainer: '.header-bar-container',
    breadCrumbContainer: '.breadcrumb-container',
    entityOfficerNewFormContainer: '.entity-officer-new-form-container'
  },

  regions: {
    headerBarContainer: '@ui.headerBarContainer',
    breadCrumbContainer: '@ui.breadCrumbContainer',
    entityOfficerNewFormContainer: '@ui.entityOfficerNewFormContainer'
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');
    var entityName = modelGet(this.model, 'entityIdentifiers.entityName');
    var officer = this.model.get('officer');

    this.showChildView(
      'headerBarContainer',
      new EntityHeaderBarView({
        model: new Backbone.Model(this.model.get('entityIdentifiers'))
      })
    );

    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#ext/nondep/dashboard'
          },
          {
            text: entityName,
            link: '#ext/nondep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'Apply to Add Officer'
          }
        ]
      })
    );

    this.showChildView(
      'entityOfficerNewFormContainer',
      new EntityOfficerNewApplication({
        viewMode: this.options.viewMode,
        isAmendment: this.options.isAmendment,
        model: new Backbone.Model({
          officerTypes: this.model.get('officerTypes'),
          officer: officer,
          entityId: entityId,
          isOfficerConvicted: modelGet(this.model, 'isOfficerConvicted'),
          isOfficerConvictedDocument: modelGet(this.model, 'isOfficerConvictedDocument')
        })
      })
    );

    Radio.channel('nd:submit-application').on('submit', function() {
      Radio.channel('navigate').trigger('show:ext:nd:entity-dashboard', entityId);
    });
  }
});
